/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  /**
   * Вид для страницы аналогов автозапчасти
   */
  app.PartAnalogView = app.View.extend({
    el: '.js-part-analogs',
    additionalOptions: ['mainWindow', 'currency'],

    /** @inheritDoc */
    run: function () {
      this.createQtyBlock();
      this.createCatalog();
    },

    /**
     * Добавить вью для добавления автозапчасти в корзину
     */
    createQtyBlock: function () {
      var data = app.helpers.TemplateHelper.getJson('#part-json');
      var cartItem = app.helpers.TemplateHelper.getJson('#cart-item-json');
      if (!data) {
        return;
      }
      var item = new app.Item(data);
      this.item = item;
      this.childViews.qtyView = new app.CategoryItemQtyView({
        el: this.$('.btn-block'),
        item: item,
        model: new app.CartItem(cartItem, {
          item: item,
        }),
        collection: new app.Collection([item]),
        cart: this.cart,
      });
      this.childViews.qtyView.render({
        controls: [false, false],
      });
    },

    /**
     * Добавить вью каталога для аналогов автозапчасти
     */
    createCatalog: function () {
      var sids = app.helpers.TemplateHelper.getJson('#analog-sids');
      if (!(_.isArray(sids) && sids.length)) {
        return;
      }
      this.collection = new app.Category();
      this.collection.sortTypes = ['price', '-price', 'supply_period', '-supply_period'];
      this.collection.queryParams.sid = sids.join(',');
      this.collection.fetchCounter = 1;
      this.router = new app.Router({
        type: 'PartAnalog',
        allowed: ['sort', 'per-page', 'f', 'mode', 'viewtype', 'currency', 'name', 'num'],
        collection: this.collection,
      });
      this.childViews.categoryCommonView = new app.CategoryCommonView({
        model: this.collection,
        router: this.router,
        cart: this.cart,
        sortTemplateId: '#main-sort-filter',
        el: '[data-jsview="partAnalog"]',
        settlement: this.settlement,
        mainWindow: this.mainWindow,
        user: this.user,
        currency: this.currency,
      });
      app.categoryCommonView = this.childViews.categoryCommonView;
      app.preloader.render();
      this.listenTo(this.collection, 'sync', this.showCatalogBlock);
    },

    /**
     * Отобразить блок с каталогом
     */
    showCatalogBlock: function () {
      app.preloader.remove();
      this.$('.js-analogs-wrapper').removeClass('not_display');
      this.$('.js-section').addClass('main b-section');
    },
  });
})(jQuery);

}.call(window));